// extracted by mini-css-extract-plugin
export var alignRight = "partners-module--alignRight--594e5";
export var arrowsContainer = "partners-module--arrowsContainer--574b6";
export var container = "partners-module--container--afa64";
export var imageContainer = "partners-module--imageContainer--a472b";
export var imageContent = "partners-module--imageContent--8fd10";
export var title = "partners-module--title--ce0db";